import { MouseEvent } from 'react'
import { useDispatch } from 'react-redux'

import { trackLinkClick } from '~/lib/analytics/actions/linkclick'
import { LINKCLICK } from '~/lib/analytics/constants'

interface ExpectedProps {
    disabled?: boolean | null
    href?: string | null
    name?: string | null
    placement?: string | null
    to?: string | null
}

export function useWithTrackLinkClick(
    props: ExpectedProps,
    onClick: (e: MouseEvent) => void,
) {
    const { disabled, href = '', name = '', placement = '', to = '' } = props

    const dispatch = useDispatch()

    const url = href || to

    return (e: MouseEvent) => {
        if (disabled) {
            return
        }

        if (onClick) {
            onClick(e)
        }

        if (dispatch) {
            dispatch(
                trackLinkClick({ type: LINKCLICK }, url, { name, placement }),
            )
        }
    }
}
